module.exports = __webpack_public_path__ + "img/login.714abf67.png";